import { render, staticRenderFns } from "./UpcomingSpinningSegment.vue?vue&type=template&id=fca34eb0&scoped=true"
import script from "./UpcomingSpinningSegment.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingSpinningSegment.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UpcomingSpinningSegment.vue?vue&type=style&index=0&id=fca34eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca34eb0",
  null
  
)

export default component.exports